import React from "react";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Tooltip from "../../components/tooltip/Tooltip";

const ICONS = {
    ELIGIBLE:   {icon: "check",  color: "#28a745", title: "Eligible"},
    INELIGIBLE: {icon: "times",  color: "#dc3545", title: "Not Eligible"},
    PENDING:    {icon: "clock",  color: "#6c757d", title: "Eligibility check pending"},
};

function EligibilityStatusIndicator({eligibilityStatus}) {
    const config = ICONS[eligibilityStatus];
    if (!config) {
        return null;
    }

    return (
        <Tooltip title={config.title}>
            <FontAwesomeIcon icon={["fas", config.icon]}
                             style={{color: config.color, fontSize: "14px"}}/>
        </Tooltip>
    );
}

EligibilityStatusIndicator.propTypes = {
    eligibilityStatus: PropTypes.oneOf(["ELIGIBLE", "INELIGIBLE", "PENDING"]),
};

EligibilityStatusIndicator.defaultProps = {
    eligibilityStatus: null,
};

export default EligibilityStatusIndicator;
